import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * interfaces
 */
import { IUserInfoDto } from '../../interfaces';

/**
 * consts
*/
import { UserConst } from '@identity/user';

/**
 * httpHandler
 */
import { IResponse } from '@network';

/**
 * Service for making HTTP requests to user-related API endpoints.
 * 
 * This service handles all communication with the backend API for user data.
 * It returns data transfer objects that need to be converted to models before
 * being used in the application. The conversion happens automatically when you
 * use the user service's setUserInfo method.
 */
@Injectable()
export class UserApiService {

  /**
   * Creates a new instance of the user API service.
   * 
   * @param _http - The Angular HTTP client used to make requests
   */
  constructor(private _http: HttpClient) { }

  /**
   * Fetches the current user's information from the API.
   * 
   * This method makes a GET request to retrieve the logged-in user's profile
   * information. The response comes back as a data transfer object with
   * snake_case property names like first_name and role_id.
   * 
   * You typically don't call this method directly. Instead, use the user
   * service or the route resolver which will handle the conversion to
   * a model automatically.
   * 
   * @returns An observable that emits the API response containing user data
   */
  public GET_USER_INFO(): Observable<IResponse<IUserInfoDto>> {
    return this._http.get<IResponse<IUserInfoDto>>(UserConst.GET_USER_INFO_ENDPOINT);
  }

}